import React from 'react';
import type { SceneElement } from '../../types';
import {
  getElementChipMeta,
  getElementTypeIcon,
  type OpenSceneInEditorHandler,
} from './inline-elements-model';
import styles from './inline-editor.module.css';

interface InlineElementsStripProps {
  sceneId: string;
  elements: SceneElement[];
  onOpenSceneInEditor?: OpenSceneInEditorHandler;
}

export const InlineElementsStrip: React.FC<InlineElementsStripProps> = ({
  sceneId,
  elements,
  onOpenSceneInEditor,
}) => {
  if (elements.length === 0) return null;

  return (
    <div className={styles.elementsStrip}>
      <div className={styles.elementsLabel}>
        Éléments overlay ({elements.length})
      </div>
      <div className={styles.elementsChipRow}>
        {elements.map((element) => {
          const meta = getElementChipMeta(element);
          const chip = (
            <>
              <span className={styles.elementChipIcon} aria-hidden>
                {getElementTypeIcon(element.type)}
              </span>
              <span className={styles.elementChipId}>{element.id}</span>
              {meta.length > 1 && (
                <span className={styles.elementChipMeta}>{meta.slice(1).join(' · ')}</span>
              )}
            </>
          );

          if (!onOpenSceneInEditor) {
            return (
              <span key={element.id} className={styles.elementChip}>
                {chip}
              </span>
            );
          }

          return (
            <button
              key={element.id}
              type="button"
              className={`${styles.elementChip} ${styles.elementChipButton}`}
              title={`Ouvrir ${element.id} dans l'éditeur Scènes`}
              onClick={() => onOpenSceneInEditor(sceneId, element.id)}
            >
              {chip}
              <span className={styles.elementChipLinkHint} aria-hidden>↗</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
